export default __webpack_public_path__ + "static/media/m-slide-1.bb0df82e.png";